import {
  FrescuraDeDatosSchema,
  ListaDeCargasSchema,
  ResultadoDeCargaSchema,
  ResultadoDelLoteSchema,
  VistaPreviaDeCambiosSchema,
  VistaPreviaDeCargaSchema,
  type AplicarCarga,
  type OpcionesDeCarga,
} from '@cnc/contracts';
import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';
import {json, pedir} from './cliente';
import {refrescarDatos} from './refrescar';

export function useCargas() {
  return useQuery({
    queryKey: ['cargas', 'lista'],
    queryFn: () => pedir('cargas', ListaDeCargasSchema),
  });
}

// Ultima carga de cada archivo (tablero de inicio).
export function useFrescuraDeDatos() {
  return useQuery({
    queryKey: ['cargas', 'frescura'],
    queryFn: () => pedir('cargas/frescura', FrescuraDeDatosSchema),
    staleTime: 60_000,
  });
}

export function useSubirControlDeEmpaque() {
  const cliente = useQueryClient();
  return useMutation({
    mutationFn: ({archivo, opciones}: {archivo: File; opciones: OpcionesDeCarga}) => {
      const cuerpo = new FormData();
      cuerpo.append('archivo', archivo, archivo.name);
      if (opciones.recoleccion) cuerpo.append('recoleccion', opciones.recoleccion);
      if (opciones.fechaRecoleccion) cuerpo.append('fechaRecoleccion', opciones.fechaRecoleccion);
      return pedir('cargas/control-de-empaque', VistaPreviaDeCargaSchema, {method: 'POST', body: cuerpo});
    },
    onSuccess: () => cliente.invalidateQueries({queryKey: ['cargas']}),
  });
}

export function useAplicarCarga() {
  const cliente = useQueryClient();
  return useMutation({
    // Con los meses de molienda elegidos y la entrada a bodega de la recoleccion.
    mutationFn: ({id, pedido}: {id: number; pedido: AplicarCarga}) =>
      pedir(`cargas/${id}/aplicar`, ResultadoDeCargaSchema, json('POST', pedido)),
    onSuccess: () => refrescarDatos(cliente),
  });
}

// Cambios de exportaciones desde un Excel: revisar y aplicar.
export function useSubirCambiosDeExportaciones() {
  const cliente = useQueryClient();
  return useMutation({
    mutationFn: ({archivo, crearNuevas}: {archivo: File; crearNuevas: boolean}) => {
      const cuerpo = new FormData();
      cuerpo.append('archivo', archivo, archivo.name);
      cuerpo.append('crearNuevas', crearNuevas ? 'true' : 'false');
      return pedir('cargas/cambios-de-exportaciones', VistaPreviaDeCambiosSchema, {method: 'POST', body: cuerpo});
    },
    onSuccess: () => cliente.invalidateQueries({queryKey: ['cargas']}),
  });
}

export function useAplicarCambiosDeExportaciones() {
  const cliente = useQueryClient();
  return useMutation({
    // Sin "elegidos" se aplica todo; con ellos, solo esos campos de esas exportaciones.
    mutationFn: ({id, elegidos}: {id: number; elegidos?: Array<{codigo: string; campos: string[]}>}) =>
      pedir(`cargas/cambios-de-exportaciones/${id}/aplicar`, ResultadoDelLoteSchema, {
        method: 'POST',
        headers: {'content-type': 'application/json'},
        body: JSON.stringify(elegidos ? {elegidos} : {}),
      }),
    onSuccess: () => refrescarDatos(cliente),
  });
}
